export const styles = {
  itemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    marginBottom: 5,
  },
}



// WEBPACK FOOTER //
// ./src/Containers/Clients/ClientView/styles.js